import { render, staticRenderFns } from "./ListPointProgram.vue?vue&type=template&id=e24eadc8&scoped=true&"
import script from "./ListPointProgram.vue?vue&type=script&lang=js&"
export * from "./ListPointProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24eadc8",
  null
  
)

export default component.exports